import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { CommonModule, Location } from '@angular/common';
import { RoutingService } from '../../services/routing.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { environment } from '../../../../environments/environment';
import { MatInputModule } from '@angular/material/input';
import { SearchComponent } from '../search/search.component';
import { MatListModule } from '@angular/material/list';

@Component({
  standalone: true,
  selector: 'app-toolbar',
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    SearchComponent,
    MatListModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.sass'],
})
export class ToolbarComponent implements OnInit {
  testEnvironment = !environment.production;
  constructor(
    private layoutService: LayoutService,
    private authService: MsalService,
    private locationService: Location,
    private routingService: RoutingService
  ) {}

  get pageTitle$(): Observable<string> {
    return this.layoutService.pageTitle$;
  }

  returnBackButton$ = this.routingService.lastRouteData('addReturnButton');

  // When a route sets `fullscreen: true` (e.g. the hoses machine dashboard),
  // hide the search bar, test banner and page-title bar to maximize screen
  // space — keeping only the sidebar toggle and the user/logout menu.
  fullscreen$ = this.routingService.lastRouteData<boolean>('fullscreen');

  userName: string;

  ngOnInit(): void {
    this.userName = this.authService.instance.getActiveAccount().username;
  }

  onClickSideNavChangeButton(): void {
    this.layoutService.reverseSideNavChange();
  }

  onClickSignOffButton(): void {
    localStorage.removeItem('currentUser');
    this.authService.logout();
  }

  onClickBackButton(): void {
    this.locationService.back();
  }
}
